import styles from "./TopBarBodyStart.module.scss"
import { TopBarBodyStartProps } from "./TopBarBodyStart.types"

export default function TopBarBodyStart(props: TopBarBodyStartProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
